import { LayoutConfiguration } from '@mctic/ng-core';
import * as npm from './../../package.json';

export const layoutConfiguration: LayoutConfiguration = {
  navbar: {
    header: 'NOVO SIGPLANI',
    description: 'Sistema de Gestão da Lei da Informática e do PADIS'
  },
  footer: {
    frontendVersion: npm.version,
    backendVersion: 'INDISPONÍVEL'
  }
};

export const environment: any = {
  layout: layoutConfiguration,
  urlKeycloak: 'https://sso.dsv.app.mctic.gov.br/auth',
  enableRouteTracing: false,
  gzp: '${apiKey}',
  azp: '${apiSecret}'
};
